import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconButton, makeStyles, Typography } from '@material-ui/core';
import FactorSelect from './FactorSelect';
import TextInput from '../../UI/inputs/TextInput';
import { Close } from '@material-ui/icons';
import useCheckMobileScreen from '../../../hooks/useWidth';

const useStyle = makeStyles((theme) => ({
    container: {},
    content: {
        display: 'flex',
        direction: 'ltr',
        width: '100%',
        height: '100%',
        padding: '16px 0',
        // padding: 16,
        alignItems: 'center',
        [theme.breakpoints.down(1025)]: {
            padding: '26px 0'
        }
    },
    title: {
        width: 200,
        margin: '0px 10px'
    },
    values: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: 5,
        height: 'min-content',
        marginLeft: 30,
        [theme.breakpoints.down(1025)]: {
            alignItems: 'unset',
            flex: 1,
            marginLeft: 10,
            // width: '50%',
            '& > div': {
                width: '100%'
            }
        }
    },
    groupName: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        width: 100,
        fontSize: '1.1rem',
        [theme.breakpoints.down(1025)]: {
            width: 80,
            display: ({ isNewFactor }) => isNewFactor && 'none'
        }
    },
    close: {
        width: 15,
        height: 15
    },
    input: {
        width: 150,
        textAlign: 'center !important'
    },

    abnormalInput: {
        width: 150,
        textAlign: 'center !important',
        color: theme.palette.error.main
    }
}));
const mobileStyles = makeStyles((theme) => ({
    mobileSelect: ({ isNewFactor }) => ({
        width: 150,
        [theme.breakpoints.down(1025)]: {
            width: !isNewFactor ? 150 : '50%',
            flex: 1,
            textAlign: 'center !important'
        },
        '& > div > div': {
            border: !isNewFactor && 'none !important',
            borderRadius: !isNewFactor && '0 ',
            borderBottom: !isNewFactor && '1px solid #ced2d6 !important'
        }
    }),

    mobileInput: ({ isNewFactor }) => ({
        width: !isNewFactor && 150,
        textAlign: 'center !important'
    })
}));

/**
 * @typedef {{abnormal: boolean,normal_range: string,unit: string,value: number}} FactorValue
 * @typedef {{name: string,default_normal_range: string,default_unit: number}} Factor
 * @typedef {(factorValue: {value: any,factor_id: number}) => void} onDelete
 * @param {{groupId: number,factor: Factor,factorValue: FactorValue,isNewFactor: boolean,handleChange(factorId,value):void,handleFactorChange(factor):void,handleDelete:onDelete}} props
 */
export default function Item({
    factor,
    factorValue,
    isNewFactor = false,
    handleChange,
    handleFactorChange,
    groupId,
    handleDelete,
    focus
}) {
    const isMobile = useCheckMobileScreen();
    const classes = useStyle({ isNewFactor });
    const mobileClasses = mobileStyles({ isNewFactor });
    const inputRef = useRef();

    useEffect(() => {
        focus && inputRef.current?.focus && inputRef.current.focus();
    }, [focus]);
    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <div className={classes.groupName}>
                    {!isNewFactor && (
                        <>
                            <IconButton
                                size="small"
                                onClick={handleDelete}
                                data-testid="deleteIcon"
                            >
                                <Close className={classes.close} />
                            </IconButton>
                            <Typography variant="inherit">{factor?.group?.title}</Typography>
                        </>
                    )}
                </div>
                <FactorSelect
                    className={`${classes.title} ${mobileClasses.mobileSelect}`}
                    isLab
                    value={factor}
                    onChange={handleFactorChange}
                    name="factor_id"
                    autoFocus
                    variant="outlined"
                    groupId={groupId}
                    label={isNewFactor ? 'Factor' : ''}
                />
                <div className={classes.values}>
                    <TextInput
                        isMobile={isMobile}
                        isNewFactor={isNewFactor}
                        value={factorValue.value}
                        name="value"
                        onChange={handleChange}
                        label={isNewFactor ? 'Value' : ''}
                        className={
                            factorValue.abnormal
                                ? classes.abnormalInput
                                : isMobile
                                ? mobileClasses.mobileInput
                                : classes.input
                        }
                        inputRef={inputRef}
                    />
                </div>
            </div>
        </div>
    );
}

Item.propTypes = {
    factor: PropTypes.object.isRequired,
    factorValue: PropTypes.object.isRequired,
    isEditable: PropTypes.bool,
    isNewFactor: PropTypes.bool,
    handleChange: PropTypes.func,
    handleFactorChange: PropTypes.func,
    handleDelete: PropTypes.func,
    groupId: PropTypes.number,
    focus: PropTypes.bool
};
